<template>
  <div v-show="showCoupon" class="activity">
    <div class="activity__content">
      <div class="activity__main">
        <div class="activity__title">
          <p>
            <span>好物</span>
            <span v-if="show618" class="act"></span>
            <span>超级红包</span>
          </p>
          <P>已放入您的卡包</P>
        </div>
        <div :class="couponClass">
          <div v-for="(item, index) in couponList" :key="index" class="activity__coupon-item">
            <div class="activity__coupon-item--main">
              <div>
                <b>￥</b>
                <span>{{ item.money }}</span>
              </div>
              <div>满{{ Number(item.condition).toFixed(0) }}元可用</div>
            </div>
          </div>
        </div>
        <div class="activity__radian"></div>
        <div class="activity__button" @click="showCoupon=false">马上购物</div>
        <div class="activity__tip">可以去<span>个人中心-优惠劵</span>里面查看哦～</div>
      </div>
      <!-- <div class="activity__close">
        <i class="icon toast_error" @click="showCoupon=false"></i>
      </div> -->
    </div>
  </div>
</template>
<script>
import * as couponApis from 'apis/coupon';

export default {
  data() {
    return {
      couponList: [],
      showCoupon: false,
      show618: false,
    };
  },
  computed: {
    couponClass() {
      let str = 'activity__coupon scroll-touch';
      if (this.couponList.length === 1) {
        str += ' center';
      }
      return str;
    },
  },
  created() {
    setTimeout(() => {
      this.fetchCouponList();
    }, 500);
  },
  methods: {
    async fetchCouponList() {
      const data = await couponApis.getCouponList();
      if (Array.isArray(data)) {
        this.couponList = data.filter(f => f.isNew === 1);
        const nowTime = new Date();
        const year = nowTime.getFullYear();
        const month = nowTime.getMonth() + 1;
        const date = nowTime.getDate();
        this.show618 = year === 2019 && month === 6 && date < 19;
        this.showCoupon = this.couponList.length;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.activity {
  z-index: 1000000;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;

  &__content {
    width: 688px;
  }

  &__main {
    height: 834px;
    background: url("~assets/img/activity_bg.png") no-repeat;
    background-size: contain;
    padding-top: 200px;
    box-sizing: border-box;
    position: relative;
  }

  &__title {
    width: 392px;
    margin: 0 auto;

    p {
      font-size: 22px;
      color: #fff;
      text-align: center;

      &:first-of-type {
        font-size: 34px;
        display: flex;
        font-weight: bold;
        align-items: center;
        justify-content: center;

        span {
          height: 47px;
        }

        .act {
          width: 104px;
          height: 81px;
          background: url("~assets/img/activity_618.png") no-repeat;
          background-size: contain;
        }
      }
    }
  }

  .center {
    justify-content: center;
    align-items: center;
  }

  &__coupon {
    width: 392px;
    height: 300px;
    margin: 15px auto 40px auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-item {
      width: 179px;
      height: 118px;
      background: url("~assets/img/coupon.png") no-repeat;
      background-size: contain;
      padding: 0px 32px 11px 28px;
      box-sizing: border-box;
      margin-bottom: 14px;

      &--main {
        height: 100%;
        width: 100%;
        color: #fff;

        div {
          width: 100%;
          text-align: center;

          &:first-of-type {
            height: 66px;
            line-height: 66px;

            b {
              font-size: 24px;
            }

            span {
              font-size: 47px;
            }
          }

          &:last-of-type {
            line-height: 24px;
            font-size: 17px;
            margin-top: 3px;
          }
        }
      }
    }
  }

  &__radian {
    width: 510px;
    height: 257px;
    position: absolute;
    z-index: 100;
    bottom: 0px;
    left: 102px;
    background: url("~assets/img/activity_radian.png") no-repeat;
    background-size: contain;
  }

  &__button {
    width: 251px;
    height: 77px;
    line-height: 77px;
    font-size: 30px;
    text-align: center;
    position: absolute;
    bottom: 96px;
    z-index: 101;
    left: calc(50% - 120px);
    color: #fff;
    margin: 0 auto;
    background: linear-gradient(180deg, rgba(250, 132, 27, 1) 0%, rgba(255, 80, 31, 1) 100%);
    box-shadow: 0px 2px 9px 3px rgba(255, 112, 43, 1);
    border-radius: 44px;
  }

  &__tip {
    position: absolute;
    bottom: 35px;
    left: 160px;
    z-index: 101;
    font-size: 24px;
    color: #fff;
    text-align: center;

    span {
      font-size: 26px;
      font-weight: bold;
    }
  }

  &__close {
    margin-top: 31px;
    line-height: 1;
    text-align: center;

    i {
      width: 61px;
      height: 61px;
    }
  }
}
</style>

